function HomeCoverTypeTransformer(jsonMapper, util, quoteOptions) {
	function transform(intermediateRequest, coverType, offering) {

		// intermediateRequest.dwellings[0].coverType =  coverType.descriptor;
		intermediateRequest.dwellings[0].offering =  (offering.descriptor)?offering.descriptor:offering;
		intermediateRequest.dwellings[0].coverType =  coverType;

		return intermediateRequest;
	}

	return {
		transform: transform
	}
}
